import { useRef, useState } from "react";
import { ImageUp, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { Card, Spinner } from "@/components/common";
import { Button } from "@/components/ui/button";
import { BrandLogo, refreshBranding, useBranding } from "@/components/BrandLogo";

export default function LogoTab() {
  const b = useBranding();
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const act = async (fn, ok) => {
    setBusy(true);
    try {
      await fn();
      await refreshBranding();
      toast.success(ok);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  const upload = (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    act(() => api.put("/branding/logo", fd, { headers: { "Content-Type": "multipart/form-data" } }), "Logo updated");
  };
  return (
    <Card title="Company logo" subtitle="Shown at the top of the sidebar, on the login page and on PDF meeting reports. PNG with a transparent background works best (max 1 MB). SVG logos show in the app but not in PDFs." testid="logo-card">
      <div className="flex flex-col gap-6 sm:flex-row sm:items-center">
        <div className="flex h-28 w-56 items-center justify-center rounded-2xl border border-dashed border-slate-300 bg-slate-50 p-4" data-testid="logo-preview">
          <BrandLogo className="max-h-20" testid="logo-preview-img" />
        </div>
        <div className="flex flex-wrap gap-2">
          <input ref={input} type="file" accept="image/png,image/jpeg,image/webp,image/svg+xml" className="hidden" onChange={(e) => { upload(e.target.files?.[0]); e.target.value = ""; }} data-testid="logo-file-input" />
          <Button className="h-11 rounded-xl" onClick={() => input.current?.click()} disabled={busy} data-testid="logo-upload-button">
            {busy ? <Spinner className="mr-2 h-4 w-4" /> : <ImageUp className="mr-2 h-4 w-4" />}{b?.has_logo ? "Replace logo" : "Upload logo"}
          </Button>
          {b?.has_logo && (
            <Button variant="outline" className="h-11 rounded-xl" onClick={() => act(() => api.delete("/branding/logo"), "Logo removed")} disabled={busy} data-testid="logo-remove-button">
              <Trash2 className="mr-2 h-4 w-4" />Remove
            </Button>
          )}
        </div>
      </div>
    </Card>
  );
}
